export default "__VITE_ASSET__ne3FwK6D__"